export const pluralPl = (n: number, one: string, few: string, many: string): string => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (n === 1) return one;
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
    return many;
};

export const describeAlbum = (photoCount: number, albumCount: number): string => {
    const parts: string[] = [];
    if (photoCount > 0) parts.push(`${photoCount} ${pluralPl(photoCount, 'zdjęcie', 'zdjęcia', 'zdjęć')}`);
    if (albumCount > 0) parts.push(`${albumCount} ${pluralPl(albumCount, 'album', 'albumy', 'albumów')}`);
    return parts.length ? parts.join(' · ') : 'Pusty album';
};
